enum SegmentNames {
  recency = 'recency',
  frequency = 'frequency',
  monetary = 'monetary',
}

export default Object.values(SegmentNames);
